export default __webpack_public_path__ + "static/media/check-up-laptop.ba3ea8c5.png";